export const translations = {
  tr: {
    app_name: 'Hafızım',
    welcome: 'Hoş Geldiniz',
    kids_mode: 'Çocuk Modu',
    adult_mode: 'Yetişkin Modu',
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    logout: 'Çıkış',
    email: 'E-posta',
    password: 'Şifre',
    name: 'İsim',
    age_group: 'Yaş Grubu',
    dashboard: 'Kontrol Paneli',
    practice: 'Ezber Çalış',
    statistics: 'İstatistikler',
    settings: 'Ayarlar',
    select_surah: 'Sure Seç',
    select_ayah: 'Ayet Seç',
    start_practice: 'Çalışmaya Başla',
    stop_practice: 'Durdur',
    continue: 'Devam Et',
    listening: 'Dinleniyor...',
    correct: 'Doğru!',
    incorrect: 'Hatalı',
    try_again: 'Tekrar Dene',
    total_attempts: 'Toplam Deneme',
    successful_attempts: 'Başarılı Deneme',
    total_errors: 'Toplam Hata',
    success_rate: 'Başarı Oranı',
    recent_practice: 'Son Çalışmalar',
    language: 'Dil',
    hero_title_kids: 'Kur\'an Öğren, Eğlen!',
    hero_subtitle_kids: 'Renkli dünyamızda Kur\'an ezberlemeyi öğren',
    hero_title_adults: 'Hafızlık Yolculuğunuzda Yanınızdayız',
    hero_subtitle_adults: 'Kur\'an ezberinizi yapay zeka destekli platformumuzla güçlendirin',
    get_started: 'Hemen Başla',
    how_it_works: 'Nasıl Çalışır?',
    step1: '1. Sure ve Ayet Seç',
    step2: '2. Sesli Oku',
    step3: '3. Anında Geri Bildirim Al',
    features: 'Özellikler',
    feature1_title: 'Ses Tanıma',
    feature1_desc: 'Gelişmiş yapay zeka ile okuyuşunuz dinlenir',
    feature2_title: 'Hata Takibi',
    feature2_desc: 'Hatalarınız kaydedilir ve gelişiminiz takip edilir',
    feature3_title: 'Kişisel İstatistikler',
    feature3_desc: 'İlerlemenizi grafiklerle görün',
  },
  en: {
    app_name: 'Hafızım',
    welcome: 'Welcome',
    kids_mode: 'Kids Mode',
    adult_mode: 'Adult Mode',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    age_group: 'Age Group',
    dashboard: 'Dashboard',
    practice: 'Practice',
    statistics: 'Statistics',
    settings: 'Settings',
    select_surah: 'Select Surah',
    select_ayah: 'Select Ayah',
    start_practice: 'Start Practice',
    stop_practice: 'Stop',
    continue: 'Continue',
    listening: 'Listening...',
    correct: 'Correct!',
    incorrect: 'Incorrect',
    try_again: 'Try Again',
    total_attempts: 'Total Attempts',
    successful_attempts: 'Successful Attempts',
    total_errors: 'Total Errors',
    success_rate: 'Success Rate',
    recent_practice: 'Recent Practice',
    language: 'Language',
    hero_title_kids: 'Learn Quran, Have Fun!',
    hero_subtitle_kids: 'Learn to memorize Quran in our colorful world',
    hero_title_adults: 'Your Companion in Memorization Journey',
    hero_subtitle_adults: 'Strengthen your Quran memorization with our AI-powered platform',
    get_started: 'Get Started',
    how_it_works: 'How It Works',
    step1: '1. Select Surah & Ayah',
    step2: '2. Recite Aloud',
    step3: '3. Get Instant Feedback',
    features: 'Features',
    feature1_title: 'Voice Recognition',
    feature1_desc: 'Your recitation is listened with advanced AI',
    feature2_title: 'Error Tracking',
    feature2_desc: 'Your mistakes are recorded and progress tracked',
    feature3_title: 'Personal Statistics',
    feature3_desc: 'See your progress with charts',
  },
  ar: {
    app_name: 'حافظي',
    welcome: 'أهلا وسهلا',
    kids_mode: 'وضع الأطفال',
    adult_mode: 'وضع البالغين',
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    age_group: 'الفئة العمرية',
    dashboard: 'لوحة التحكم',
    practice: 'الممارسة',
    statistics: 'الإحصائيات',
    settings: 'الإعدادات',
    select_surah: 'اختر السورة',
    select_ayah: 'اختر الآية',
    start_practice: 'ابدأ الممارسة',
    stop_practice: 'توقف',
    continue: 'استمر',
    listening: 'استمع...',
    correct: 'صحيح!',
    incorrect: 'خطأ',
    try_again: 'حاول مرة أخرى',
    total_attempts: 'إجمالي المحاولات',
    successful_attempts: 'المحاولات الناجحة',
    total_errors: 'إجمالي الأخطاء',
    success_rate: 'معدل النجاح',
    recent_practice: 'الممارسة الأخيرة',
    language: 'اللغة',
    hero_title_kids: 'تعلم القرآن واستمتع!',
    hero_subtitle_kids: 'تعلم حفظ القرآن في عالمنا الملون',
    hero_title_adults: 'رفيقك في رحلة الحفظ',
    hero_subtitle_adults: 'قوِّ حفظك للقرآن بمنصتنا المدعومة بالذكاء الاصطناعي',
    get_started: 'ابدأ الآن',
    how_it_works: 'كيف يعمل',
    step1: '١. اختر السورة والآية',
    step2: '٢. اقرأ بصوت عالٍ',
    step3: '٣. احصل على ملاحظات فورية',
    features: 'المميزات',
    feature1_title: 'التعرف على الصوت',
    feature1_desc: 'يتم الاستماع إلى تلاوتك بالذكاء الاصطناعي المتقدم',
    feature2_title: 'تتبع الأخطاء',
    feature2_desc: 'يتم تسجيل أخطائك وتتبع تقدمك',
    feature3_title: 'إحصائيات شخصية',
    feature3_desc: 'شاهد تقدمك بالرسوم البيانية',
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations['tr'][key] || key;
};
